/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ failed: NonNullable<unknown>, total: NonNullable<unknown> }} Spaces_Add_Users_Partial_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to add {failed} of {total} users." |
*
* @param {Spaces_Add_Users_Partial_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_add_users_partial_error = /** @type {((inputs: Spaces_Add_Users_Partial_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Add_Users_Partial_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.failed} von ${i?.total} Benutzern konnten nicht hinzugefügt werden.`)
	return /** @type {LocalizedString} */ (`Failed to add ${i?.failed} of ${i?.total} users.`)
});